import React from 'react';
import PropTypes from 'prop-types';
import Text from 'Components/ComponentLibrary/Atoms/Text';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import List1 from 'Components/ComponentLibrary/Components/Lists/List1';
import { makeStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import DetailListItem from './DetailListItem';

const useStyles = makeStyles(theme => ({
  emptyListBox: {
    padding: theme.spacing(2),
  },
  list: {
    display: 'flex',
    flexDirection: 'column',
    gap: `${theme.spacing(1)}px`,
  },
}));

const DetailItemsList = ({
  collection,
  isButton,
  onItemClick,
}) => {
  const classes = useStyles();
  const noItems = collection.resources().empty();

  return (
    <Box>
      {noItems
        ? (
          <Box
            className={classes.emptyListBox}
          >
            <Text
              variant={'h5'}
              color={'primaryGray'}
              value={'Items Not Found'}
            />
          </Box>
        )
        : (
          <List1
            className={classes.list}
          >
            {collection.resources().list().map((resource) => {
              return (
                <DetailListItem
                  key={resource.id()}
                  resource={resource}
                  onClick={isButton(resource) ? () => {
                    onItemClick(resource);
                  } : null}
                />
              );
            })}
          </List1>
        )
      }

    </Box>
  );
};

DetailItemsList.defaultProps = {
  onItemClick: null,
};

DetailItemsList.propTypes = {
  collection: PropTypes.object.isRequired,
  isButton: PropTypes.func.isRequired,
  onItemClick: PropTypes.func,
};

export default DetailItemsList;
